// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_60sbr","smallLinkTypography":"_1mZtJ","titleTypography":"_3E59h","cardTitleTypography":"_1TRBM","truncate":"_14DO7","base":"PXo-2","content":"_1qaui","noRecordFound":"_4BiPI","section":"_2FXSO","sectionTitle":"_2Puq9","sectionContent":"_3jdmL","sectionLoading":"hvLa1","sectionFooter":"_28O2s","callToAction":"KNuZj","footerCallToAction":"_1vOp0"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AdminCentre/AdminCentre.scss
// module id = 2649
// module chunks = 0